export default __webpack_public_path__ + "static/media/space.6e3f8ab8.less";